import React from 'react';

const CmtImage = ({ src, alt = null, ...rest }) => {
  return <img src={src} alt={alt} {...rest} />;
};

export default CmtImage;
